module.exports = __webpack_public_path__ + "img/C3.1be2a692.webp";